import React from 'react'
import Projectimg from '../../assets/images/services/process-six-img.jpg'

function ProcessSix() {
  return (
    <div>
      <section className="process-six">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-8 col-lg-6 col-md-12 col-sm-12">
              <div className="process-six-title-box">
                <div
                  className="section-three-title wow fadeInLeft animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="100ms"
                >
                  <div className="section-three-title-title">
                    <h2>
                      Focuses Delivering Superior Quality Product For growth
                      business{" "}
                    </h2>
                  </div>
                </div>
                <div
                  className="section-three-details wow fadeInLeft animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="200ms"
                >
                  <p>
                    Sed perspiciatis unde omnis natus voluptatem accusantiuc
                    doloremue laudantium totamem aperiam eaque quinventore
                    veritatis quasi architecto beatae vitae dicta ways.
                  </p>
                </div>
                <div className="row">
                  <div className="col-xl-6 col-lg-12 col-md-6 col-sm-12">
                    <div
                      className="process-six-right-detail process-six-right-detail-one wow fadeInLeft animated"
                      data-wow-duration="1500ms"
                      data-wow-delay="300ms"
                    >
                      <i className="icon-check-mark1" />
                      <h4>Web Keyword Ranking</h4>
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-12 col-md-6 col-sm-12">
                    <div
                      className="process-six-right-detail process-six-right-detail-two wow fadeInLeft animated"
                      data-wow-duration="1500ms"
                      data-wow-delay="400ms"
                    >
                      <i className="icon-check-mark1" />
                      <h4>Technical SEO Adult</h4>
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-12 col-md-6 col-sm-12">
                    <div
                      className="process-six-right-detail process-six-right-detail-three wow fadeInLeft animated"
                      data-wow-duration="1500ms"
                      data-wow-delay="500ms"
                    >
                      <i className="icon-check-mark1" />
                      <h4>Site Health Optimization</h4>
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-12 col-md-6 col-sm-12">
                    <div
                      className="process-six-right-detail process-six-right-detail-four wow fadeInLeft animated"
                      data-wow-duration="1500ms"
                      data-wow-delay="600ms"
                    >
                      <i className="icon-check-mark1" />
                      <h4>Marketing Automation</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-12 col-sm-12">
              <div
                className="process-six-img-box wow fadeInRight animated"
                data-wow-duration="1500ms"
                data-wow-delay="500ms"
              >
                <img
                  src={Projectimg}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default ProcessSix
